<template>
    <section>

        <div class="page">
            <div>
                <h2>Which country/region is the app available in?</h2>
                <h3>About stolen accounts</h3>
                <p>
                    You should never share your ToTok SMS verification code with others, not even friends or family. If
                    you're
                    tricked into sharing your code and lose access to your ToTok account, read the instructions below to
                    recover
                    your account. If you suspect someone else is using your ToTok account, you should notify family and
                    friends
                    as this individual could impersonate you in chats and groups.
                </p>
                <h3>How to recover your account</h3>
                <p>
                    Sign into ToTok with your phone number and verify your phone number by entering the 6-digit code you
                    receive
                    via SMS. Learn more about <a href="https://totok.ai/faq/ios/20201">verifying your phone number</a>
                    in our Help Center.
                </p>
                <p>
                    Once you enter the 6-digit SMS code, the individual using your account is automatically logged out.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
